<label class="minclt-label" htmlFor="SelectGrupoGlobal">Seleccione un grupo:</label>
<p-treeSelect [(ngModel)]="selectedNodes" id="SelectGrupoGlobal" class="w-full" containerStyleClass="w-full"
  [options]="treeGlobalConfig" [selectionMode]="selectionMode" filter="true"
  placeholder="Seleccione una dependencia y luego un grupo" (onNodeSelect)="onNodeSelected($event)" #treeSelect>
  <ng-template pTemplate="footer" *ngIf="showBtnOk">
    <div class="py-2  px-2 flex justify-content-end gap-3 minclt-btn-ok">
      <app-boton-svg [nombre]="'restaurar'" [color]="'amarillo'" [size]="'33'" [borderRadius]="'8'"
                [pTooltip]="'Limpiar Campo'" tooltipPosition="bottom" (click)="cleanField()"></app-boton-svg>
      <button type="button" pButton label="Aceptar" (click)="closeTreeSelect(treeSelect)"></button>
    </div>
  </ng-template>
</p-treeSelect>